import { render } from "./ReviewRow.vue?vue&type=template&id=18951ed9&scoped=true"
import script from "./ReviewRow.vue?vue&type=script&lang=js"
export * from "./ReviewRow.vue?vue&type=script&lang=js"

import "./ReviewRow.vue?vue&type=style&index=0&id=18951ed9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18951ed9"]])

export default __exports__